import { useQuery } from '@tanstack/react-query';

import { getEmailTemplates } from '../api';

export const useGetEmailTemplates = () => {
  const emailTemplatesQuery = useQuery({
    queryKey: ['emailTemplates'],
    queryFn: getEmailTemplates,
    staleTime: Infinity,
  });

  return emailTemplatesQuery;
};
